import { getActivityFeed } from  "@/api/activityFeed"
import { getFeedFilters } from "@/helpers/ActivityFeed"
import { formatDateToIfModifiedFormat, getStartAndEndDate } from "@/helpers/Dates"

import { useEffect, useRef, useState } from "react"

interface ILongPollingFilterOptions {
    selectedWorkspaces: number[],
    selectedFilters: string[]
    filterDates: Date[],
    filtersLoaded: boolean,
    isPopOut?: boolean
}



const usePollForUpdates = ({selectedWorkspaces, selectedFilters, filterDates, filtersLoaded, isPopOut}: ILongPollingFilterOptions) => {
    const [newActivitiesCount, setNewActivitiesCount] = useState<number>(0);

    const lastModified = useRef<string>(formatDateToIfModifiedFormat( new Date()));
    
    const poller = useRef<NodeJS.Timeout>()

    function updateLastModified(date: Date) {
        lastModified.current =  formatDateToIfModifiedFormat(date);
    }

    useEffect(() => {

        if( window.location.pathname.toLowerCase().includes('activityfeed') || isPopOut) {
            if(poller.current) {
                clearInterval(poller.current)
            }
            
            setNewActivitiesCount(0);
    
            if(filtersLoaded) {
                poller.current = setInterval(() => {
                    const [startDate, endDate] = getStartAndEndDate(filterDates)

                    getActivityFeed({
                        workspaceIds: selectedWorkspaces,
                        filter: getFeedFilters(selectedFilters),
                        startDate: startDate ?? undefined,
                        endDate:  endDate ?? undefined,
                        top: 20,
                        skip: 0,
                    }, {
                        "If-Modified-Since": lastModified.current
                    })
                    .then((res) => {
                        setNewActivitiesCount(res.total)
                        updateLastModified(new Date())
                    })
                }, 60000)
            }
        }
        
    },[selectedWorkspaces, selectedFilters, filterDates, filtersLoaded, isPopOut])


    return {
        newActivitiesCount,
        updateLastModified
    }
}

export default usePollForUpdates